import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M21.019 12.184c0-.207.168-.375.375-.375h2.25c.207 0 .375.168.375.375v2.25a.375.375 0 0 1-.375.375h-2.25a.375.375 0 0 1-.375-.375v-2.25Z"></path><path d="M8.394 11.809a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375h-2.25Z"></path><path fill-rule="evenodd" d="M10.88 2.742a2 2 0 0 0-2.76 0L2.62 7.98A2 2 0 0 0 2 9.428v18.381a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V9.428a2 2 0 0 0-.62-1.448l-5.5-5.238a2 2 0 0 0-2.76 0L16 7.619l-5.12-4.877Zm15.139 25.067H28V9.428L22.5 4.19 17 9.428v18.381h2.019v-7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v7Zm-5 0h3v-6h-3v6Zm-10 0h-3v-6h3v6Zm2-7v7H15V9.428L9.5 4.19 4 9.428v18.381h2.019v-7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1Z" clip-rule="evenodd"></path></g>';
export var TownhouseOutlineSVG = function TownhouseOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TownhouseOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TownhouseOutlineSVG);